import _ from 'lodash'

// *****************************************************************************

class DynamicCssRuleManagerType {
  constructor() {
    this.extra_sheet = undefined
    this.remove_method_name = undefined
    this.rules_property_name = undefined
    this.extra_rules = {}
    this.initialize()
  }

  initialize() {
    // First time, create an extra stylesheet for adding rules
    const extra_style = document.createElement('style')
    document.getElementsByTagName('head')[0].appendChild(extra_style)
    // Keep reference to actual StyleSheet object (`styleSheet` for IE < 9)
    this.extra_sheet = extra_style.sheet || extra_style.styleSheet
    // Store name of method used to remove rules (`removeRule` for IE < 9)
    this.remove_method_name = this.extra_sheet.deleteRule
      ? 'deleteRule'
      : 'removeRule'
    // Store name of property used to access rules (`rules` for IE < 9)
    this.rules_property_name = this.extra_sheet.cssRules ? 'cssRules' : 'rules'
  }

  acquire_rule() {
    return _.uniqueId('cssrule')
  }

  release_rule(rule_id) {
    this.set_rule(rule_id, '', '')
  }

  do_remove_rule(rule_id) {
    // Function called by the remove method on objects returned by addCssRule.
    let [nb, selector, contents] = this.extra_rules[rule_id]

    // console.log('removing rule', rule_id, nb, selector, contents)
    // remove rule indicated in internal array at index
    this.extra_sheet[this.remove_method_name](nb)
    // Clear internal array item representing rule that was just deleted.
    // NOTE: we do NOT splice, since the point of this array is specifically
    // to negotiate the splicing that occurs in the stylesheet itself!
    delete this.extra_rules[rule_id]

    // Then update array items as necessary to downshift remaining rule indices.
    // Can start at index + 1, since array is sparse but strictly increasing.
    // console.log(JSON.stringify(this.extra_rules))
    for (let [cur_rule_id, entry] of Object.entries(this.extra_rules)) {
      // console.log(JSON.stringify([cur_rule_id, entry]))
      if (entry[0] > nb) {
        --entry[0]
      }
    }
    // console.log(JSON.stringify(this.extra_rules))
  }

  do_add_rule(rule_id, selector, contents) {
    // summary:
    //    Dynamically adds a style rule to the document.  Returns an object
    //    with a remove method which can be called to later remove the rule.

    const nb = (this.extra_sheet.cssRules || this.extra_sheet.rules).length
    // console.log('adding rule', rule_id, nb, selector, contents)
    this.extra_rules[rule_id] = [nb, selector, contents]
    this.extra_sheet.addRule
      ? this.extra_sheet.addRule(selector, contents)
      : this.extra_sheet.insertRule(selector + '{' + contents + '}', nb)
  }

  set_rule(rule_id, new_selector, new_contents) {
    let [old_nb, old_selector, old_contents] = this.extra_rules[rule_id] || [
      -1,
      '',
      '',
    ]
    if (new_selector === old_selector && new_contents === old_contents) {
      return
    }
    if (old_contents) {
      this.do_remove_rule(rule_id)
    }
    if (new_contents) {
      this.do_add_rule(rule_id, new_selector, new_contents)
    }
  }

  get_rule(rule_id) {
    const nb = this.extra_rules[rule_id][0]
    let rule = this.extra_sheet[this.rules_property_name]
    // rule.style[prop] = value
    return rule
  }
}

export let dynamic_css_rule_manager = new DynamicCssRuleManagerType()
